import { CARD_PROGRAMS } from '@lib/constants';
import { LET_THEM_CHOOSE } from '@lib/constants/variants';

export const getBusinessName = (
  card_program: string | undefined,
  business_name: string | undefined,
  hasA: boolean = false,
  isYour: boolean = false,
) => {
  if (business_name && business_name != LET_THEM_CHOOSE)
    return business_name;

  const aText = hasA ? 'a ' : '';
  const yourText = isYour ? 'Your' : 'Their';
  switch (card_program) {
    case CARD_PROGRAMS.CHOOSE_YOUR_OWN_RESTAURANT:
      return `${aText}Restaurant of ${yourText} Choice`;
    case CARD_PROGRAMS.CHOOSE_YOUR_OWN_SPAS_SALONS:
      return `${aText}Spa or Salon of ${yourText} Choice`;
    case CARD_PROGRAMS.CHOOSE_YOUR_OWN_SERVICES:
      return `${aText}Local Service Provider of ${yourText} Choice`;
    case CARD_PROGRAMS.CHOOSE_YOUR_OWN_HOME_SERVICES:
      return `${aText}Local Home Services of ${yourText} Choice`;
    case CARD_PROGRAMS.CHOOSE_YOUR_OWN_PERSONAL_SERVICES:
      return `${aText}Local Personal Services of ${yourText} Choice`;
    case CARD_PROGRAMS.CHOOSE_YOUR_OWN_AUTO_SERVICES:
      return `${aText}Local Auto Services of ${yourText} Choice`;
    default:
      return business_name;
  }
};